import { Injectable } from '@angular/core';
import { TeamOrgChartApiService } from '@cms/apis';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { exhaustMap, map } from 'rxjs';
import { TeamOrgChartAction } from '../actions';

@Injectable()
export class TeamOrgChartEffect {
  loadItem$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(TeamOrgChartAction.loadItem),
      exhaustMap(action => {
        return this._apiService.get(action.id).pipe(map(item => TeamOrgChartAction.loadItemSuccess({ item })));
      })
    );
  });
  constructor(private _apiService: TeamOrgChartApiService, private _actions$: Actions, private _store: Store) {}
}
